import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEOHead from '@/components/SEOHead';

export const TermsOfUse = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <SEOHead />
      <div className="w-full max-w-4xl">
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors duration-200"
          >
            ← {t('cookiePolicy.backToHome')}
          </Link>
        </div>
        
        <div className="bg-card/95 backdrop-blur-md rounded-2xl border border-border p-8 shadow-2xl">
          <h1 className="text-3xl font-bold text-foreground mb-8">
            {t('termsOfUse.title')}
          </h1>
          
          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {t('termsOfUse.acceptance.title')}
              </h2>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.acceptance.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {t('termsOfUse.serviceDescription.title')}
              </h2>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.serviceDescription.content')}
              </p>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.serviceDescription.limitation')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {t('termsOfUse.userAccounts.title')}
              </h2>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.userAccounts.content')}
              </p>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.userAccounts.responsibility')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {t('termsOfUse.userContent.title')}
              </h2>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.userContent.content')}
              </p>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.userContent.moderation')}
              </p>
              <div className="bg-accent/20 border border-accent/30 rounded-lg p-4 mb-4">
                <h4 className="font-semibold text-foreground mb-2">{t('termsOfUse.userContent.prohibited.title')}</h4>
                <ul className="list-disc list-inside text-muted-foreground space-y-1">
                  <li>{t('termsOfUse.userContent.prohibited.item1')}</li>
                  <li>{t('termsOfUse.userContent.prohibited.item2')}</li>
                  <li>{t('termsOfUse.userContent.prohibited.item3')}</li>
                  <li>{t('termsOfUse.userContent.prohibited.item4')}</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {t('termsOfUse.intellectualProperty.title')}
              </h2>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.intellectualProperty.content')}
              </p>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.intellectualProperty.fairUse')}
              </p>
              <div className="bg-destructive/10 border border-destructive/30 rounded-lg p-4 mb-4">
                <h4 className="font-semibold text-foreground mb-2">{t('termsOfUse.intellectualProperty.disclaimer.title')}</h4>
                <p className="text-muted-foreground text-sm">
                  {t('termsOfUse.intellectualProperty.disclaimer.content')}
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {t('termsOfUse.liability.title')}
              </h2>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.liability.content')}
              </p>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.liability.thirdParty')}
              </p>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.liability.maximum')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {t('termsOfUse.subscription.title')}
              </h2>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.subscription.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {t('termsOfUse.modifications.title')}
              </h2>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.modifications.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {t('termsOfUse.jurisdiction.title')}
              </h2>
              <p className="text-muted-foreground mb-4">
                {t('termsOfUse.jurisdiction.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {t('termsOfUse.contact.title')}
              </h2>
              <p className="text-muted-foreground">
                {t('termsOfUse.contact.content')}{' '}
                <a href="mailto:privacy@newsforyou.ai" className="text-primary hover:underline">
                  privacy@newsforyou.ai
                </a>
              </p>
            </section>

            <div className="border-t border-border pt-6 mt-8">
              <p className="text-sm text-muted-foreground">
                {t('termsOfUse.lastUpdated', { date: new Date().toLocaleDateString() })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};